import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide29Einladung(_: SlideProps) {
  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-blau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-120px",
          left: "10%",
          background: "#fff",
          opacity: 0.10,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-100px",
          right: "5%",
          background: "var(--svo-dunkelblau)",
          opacity: 0.30,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="deck-eyebrow rise rise-1" style={{ color: "rgba(255,255,255,0.9)" }}>
          Einladung
        </div>
      </header>

      <div className="deck-hero">
        <div className="hero-statement rise rise-2">
          Meldet euch mit Ideen, Problemen, Wünschen.
        </div>
        <div className="hero-divider rise rise-3" aria-hidden="true" />
        <div
          className="hero-sub rise rise-4"
          style={{ fontStyle: "italic", fontWeight: 500 }}
        >
          Eure Erfahrung ist unser Kompass.
        </div>
      </div>
    </div>
  );
}
